import Phaser from 'phaser';

export default class BootScene extends Phaser.Scene {
  private isFontLoaded: boolean = false;
  private isAssetsLoaded: boolean = false;

  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // 画像アセットの読み込み
    this.load.image('bg', 'assets/images/bg.png');
    this.load.image('cat', 'assets/images/cat.png');
    this.load.image('fish', 'assets/images/fish.png');
    this.load.image('dog', 'assets/images/dog.png');
    this.load.image('caution', 'assets/images/caution.png');
    this.load.image('cardboard', 'assets/images/cardboard.png');
    this.load.image('ground', 'assets/images/ground.png');
    this.load.image('sounds_on', 'assets/images/sounds_on.png');
    this.load.image('sounds_off', 'assets/images/sounds_off.png');
    this.load.image('stop', 'assets/images/stop.png');
    this.load.image('logo', 'assets/images/logo.png');
    
    // 音声アセットの読み込み
    this.load.audio('bgm', 'assets/sounds/bgm.mp3');
    this.load.audio('gameover', 'assets/sounds/gameover.mp3');
    this.load.audio('meow', 'assets/sounds/meow.mp3');
    this.load.audio('meow2', 'assets/sounds/meow2.mp3');
    this.load.audio('jump', 'assets/sounds/jump.mp3');
    this.load.audio('over_score', 'assets/sounds/over_score.mp3');
    this.load.audio('button', 'assets/sounds/button.mp3');
    this.load.audio('dog_bark', 'assets/sounds/dog_bark.mp3');
    
    // アセット読み込み完了イベント
    this.load.on('complete', () => {
      this.isAssetsLoaded = true;
      this.checkAndProceed();
    });
  }

  create(): void {
    // フォントとアセットの読み込みを開始（ローディング画面なし）
    this.loadFont();
    
    // アセットが既に読み込まれている場合の確認
    if (this.load.isLoading() === false) {
      this.isAssetsLoaded = true;
      this.checkAndProceed();
    }
  }

  private loadFont(): void {
    // フォントを明示的に読み込む
    if (document.fonts && typeof document.fonts.load === 'function') {
      // Tiny5フォントとDotGothic16フォントを読み込む（相対パスを使用）
      const tiny5Font = new FontFace('Tiny5', 'url(./fonts/Tiny5-Regular.ttf)');
      const dotGothic16Font = new FontFace('DotGothic16', 'url(./fonts/DotGothic16-Regular.ttf)');
      
      Promise.all([tiny5Font.load(), dotGothic16Font.load()])
        .then((loadedFonts) => {
          // フォントをドキュメントに追加
          loadedFonts.forEach(font => document.fonts.add(font));
          this.isFontLoaded = true;
          this.checkAndProceed();
        })
        .catch((error) => {
          console.warn('フォントの読み込みに失敗しました:', error);
          // フォント読み込みに失敗した場合も進む
          this.isFontLoaded = true;
          this.checkAndProceed();
        });
    } else {
      // document.fonts APIが利用できない場合は、少し待ってから進む
      this.time.delayedCall(500, () => {
        this.isFontLoaded = true;
        this.checkAndProceed();
      });
    }
  }

  private checkAndProceed(): void {
    // フォントとアセットの両方が読み込まれたら、すぐにタイトルへ
    if (this.isFontLoaded && this.isAssetsLoaded) {
      this.proceedToTitle();
    }
  }

  private proceedToTitle(): void {
    // タイトルシーンへ遷移（game_startはPLAYボタンタップ時に呼ぶ）
    this.scene.start('TitleScene');
  }
}

